import React, {memo} from 'react';

import BarChart from '../BarChart';

function QuestionOptionsWidget({question, answers, id, options, unPin}) {
  const answersByQuestionOption = answers.reduce((map, answer) => {
    if(!map[answer.value]) {
      map[answer.value] = [];
    }

    map[answer.value].push(answer);
    return map;
  }, {});

  var data;
  if(!doWeHaveOrder(question.questionOptions)) {
    data = question.questionOptions
      .sort((a,b) => a.value.trim().toLowerCase().localeCompare(b.value.trim().toLowerCase()))
      .map((option, i) => ({
        name: option.value,
        index: i + 1,
        value: (answersByQuestionOption[option.value] || []).length
    }));
  } else {
      data = question.questionOptions
        .sort((a,b) => a.order - b.order)
        .map(option => ({
          name: option.value,
          index: option.order + 1,
          value: (answersByQuestionOption[option.value] || []).length
      }));
  }

  return (
    <BarChart 
      title={question.text} 
      data={data} 
      total={answers.length} 
      id={id} options={options} 
      unPin={unPin} 
      question={question}
    />
  );
};

function doWeHaveOrder(questionArr) {
  let zeroCount = 0;
  for(let question of questionArr) {
    if(question.order === 0){
      zeroCount++;
    }
    if (zeroCount > 1){
      return false;
    }
  }
  return true;
}

export default memo(QuestionOptionsWidget);
